import styled from "styled-components";
import {FormGroup as Group, FormLabel, FormControl as TextInput, InputGroup as inputGroup} from "react-bootstrap";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const TopBackground = styled.div`
  background: ${({ theme }) =>
  `linear-gradient(to right, ${theme.primary?.[700]}, ${theme.primary?.[400]})`};
  height: 30vh;
  width: 100%;
`;

export const BottomBackground = styled.div`
  background: #fff;
  display: flex;
  height: 50vh;
  width: 100%;
`;

export const Box = styled.div`
  position: absolute;
`;

export const LoginSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-radius: 10px;
  border: ${({theme} )=> `2px dashed ${theme.primary}`};
  padding: 20px;
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px auto 0 auto;
`

export const FormGroup = styled(Group)`
`

export const Label = styled(FormLabel)`
  color: ${({theme}) => theme.color};
  font-weight: 600;
  padding-left: 10px;
  font-size: 14px;
`;

export const FormControl = styled(TextInput)`
  border-color: ${({theme}) => theme.primary};
  height: 45px;
  
  &:focus, &:active{
    outline: none;
    box-shadow: none;
    border-color: unset;
  }
`

export const InputGroup = styled(inputGroup)`
  border: ${({theme}) => `1px solid ${theme.primary}`};
  border-radius: 10px;
  
  .form-control {
    border: none;
    border-radius: 10px;
    height: 43px;
  }
  
  button {
    border-radius: 10px;
    width: 40px;
    img {
      height: 20px;
      width: 20px;
    }
  }
`

export const ErrorText = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #b21d1d;
  margin-left: 5px;
`

export const Form = styled.form`
  width: 400px;
  margin: 40px auto 0 auto;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({$gap}) => $gap};
`;

export const Title = styled.p`
  font-size: 26px;
  font-weight: 800;
  text-align: center;
  margin-bottom: 10px;
  color: ${({$error}) => $error ? "#b21d1d" : "#000"}
`

export const Description = styled.p`
  font-size: 14px;
  text-align: center;
`
